import Post from 'app/utils/Post';

export const sendError = (errorObj: string): void => {
    new Post({
        params: {message: errorObj},
        url: '/send_error'
    }).execute();
};
